import { Text } from '@/shared/ui/primitives';
import type { CSSProperties, FC, ReactNode } from 'react';
import styles from './Pill.module.css';

export type PillTone = 'success' | 'warning' | 'neutral' | 'destructive' | 'info';

export type PillMode = 'fill' | 'outline';

const TONE_COLOR: Record<PillTone, string> = {
  success: 'var(--shanti-success-color)',
  warning: 'var(--shanti-warning-color)',
  neutral: 'var(--shanti-hint)',
  destructive: 'var(--shanti-danger)',
  info: 'var(--shanti-accent)',
};

export const toneColor = (tone: PillTone): string => TONE_COLOR[tone];

interface PillProps {
  tone: PillTone;
  mode?: PillMode;
  children: ReactNode;
}

export const Pill: FC<PillProps> = ({ tone, mode = 'fill', children }) => {
  const style = { '--pill-fg': toneColor(tone) } as CSSProperties;
  const className = mode === 'outline' ? `${styles.pill} ${styles.outline}` : styles.pill;
  return (
    <span className={className} style={style}>
      <Text variant="caption" weight="medium">
        {children}
      </Text>
    </span>
  );
};
